import React from 'react';
import PropTypes from 'prop-types';
import { required, TextInput } from 'react-admin';
import validateCnpj from './validator';
import CnpjFormatInput from './cnpj-format';
import LABELS from './labels';

const CnpjInput = props => {
  const {
    label,
    source,
    dataTestId,
    variant,
    hasWritePermissions,
    isEditPage,
    isRequired,
    readOnly
  } = props;

  const validations = [validateCnpj(isEditPage)];
  if (isRequired) validations.push(required());

  return (
    <TextInput
      label={label}
      source={source}
      data-testid={dataTestId}
      validate={validations}
      InputProps={{
        inputComponent: CnpjFormatInput
      }}
      variant={variant}
      disabled={readOnly || !hasWritePermissions}
    />
  );
};

CnpjInput.defaultProps = {
  label: LABELS.CNPJ,
  dataTestId: LABELS.CNPJ_DATA_TEST_ID,
  variant: 'outlined',
  hasWritePermissions: true,
  isEditPage: true,
  isRequired: false,
  readOnly: false
};

CnpjInput.propTypes = {
  label: PropTypes.string,
  source: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  variant: PropTypes.string,
  hasWritePermissions: PropTypes.bool,
  isEditPage: PropTypes.bool,
  isRequired: PropTypes.bool,
  readOnly: PropTypes.bool
};

export default CnpjInput;
